if (!customElements.get('share-page-button')) {
  customElements.define(
    'share-page-button',
    class SharePageButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.tooltip = this.querySelector('.tooltip');
        this.status = this.querySelector('[data-share-status]');
        this.label = this.tooltip ? this.tooltip.textContent : '';
        this.button?.addEventListener('click', () => this.share());
      }

      // The device's share sheet where there is one (phones, most browsers), else copy the link.
      // The current URL keeps the shopper's selected variant.
      async share() {
        const data = { title: document.title, url: window.location.href };

        if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
          try {
            await navigator.share(data);
            return;
          } catch (error) {
            if (error.name === 'AbortError') return;
          }
        }

        try {
          await navigator.clipboard.writeText(data.url);
          this.announce(this.dataset.copiedText);
        } catch (error) {
          this.announce(this.dataset.failedText);
        }
      }

      announce(text) {
        if (!text) return;
        if (this.status) this.status.textContent = text;
        if (!this.tooltip) return;

        this.tooltip.textContent = text;
        this.button.classList.add('tooltip--is-visible');
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.button.classList.remove('tooltip--is-visible');
          this.tooltip.textContent = this.label;
          if (this.status) this.status.textContent = '';
        }, 2000);
      }
    }
  );
}
